/* eslint-disable */

import React from "react";
import ReactDOM from "react-dom";
import classnames from "classnames";
import { PhotoSwipe } from "react-photoswipe/dist/react-photoswipe";
import OriginalPhotoswipe from "./PhotoSwipeOriginalCustom.js";
import PhotoswipeUIDefault from "photoswipe/dist/photoswipe-ui-default";
import "./PhotoSwipeCustom.scss";
import { renderHTML } from "../../utils/misc";
import events from "./events";
import { NavigateBeforeIcon, NavigateNextIcon, InfoIcon } from "~/theme/assets";
import { defineMessages, FormattedMessage } from "react-intl";
import styles from "../ImageGallery/MobileGallery.scss";

const msgs = defineMessages({
  book: {
    id: "room_selection.gallery.book",
    description: "book",
    defaultMessage: "book",
  },
  close: {
    id: "bookingModification.modal.close",
    description: "close",
    defaultMessage: "close",
  },
});

export default class PhotoSwipeCustom extends PhotoSwipe {
  constructor(props) {
    super(props);
    this.handleDescription = this.handleDescription.bind(this);
    this.handleNext = this.handleNext.bind(this);
    this.handlePrev = this.handlePrev.bind(this);
    this.state = {
      ...this.state,
      captionExpand: false,
    };
  }

  handleDescription(event) {
    event.preventDefault();
    event.stopPropagation();
    this.setState({ captionExpand: !this.state.captionExpand });
  }

  openPhotoSwipe = props => {
    let { items, options, ...other } = props;
    let pswpElement = ReactDOM.findDOMNode(this);
    options = {
      ...options,
      history: false,
      maxSpreadZoom: 1,
      zoomEl: false,
      getDoubleTapZoom: (isMouseClick, item) => {
        return item.initialZoomLevel;
      },
    };

    this.photoSwipe = new OriginalPhotoswipe(pswpElement, PhotoswipeUIDefault, items, options);
    events.forEach(event => {
      let callback = props[event];
      if (callback || event === "destroy") {
        let self = this;
        this.photoSwipe.listen(event, function () {
          if (callback) {
            let args = arguments.length === 1 ? [arguments[0]] : Array.apply(null, arguments);
            args.unshift(this);
            callback(...args);
          }
          if (event === "destroy") {
            self.handleClose();
          }
        });
      }
    });
    this.setState(
      {
        isOpen: true,
        captionExpand: false,
      },
      () => {
        this.photoSwipe.init();
      }
    );
  };

  handleNext(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    if (this.photoSwipe) {
      this.photoSwipe.next();
    }
  }

  handlePrev(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    if (this.photoSwipe) {
      this.photoSwipe.prev();
    }
  }

  closeModal = () => {
    document.removeEventListener("keydown", this.closeModal, false);
    this.props.handleClose();
  };

  componentDidMount() {
    document.addEventListener(
      "keydown",
      () => {
        if (event.keyCode === 27) {
          this.closeModal();
        }
      },
      false
    );
  }

  render() {
    const { handleDescription, handleNext, handlePrev } = this;
    const { title, description, captionTop, handleInventory, type, infoOnly } = this.props;
    let { className, showReadMore, inventory } = this.props;
    const { captionExpand } = this.state;
    className = classnames(["pswp", className]).trim();
    return (
      <div id="photoSwipeCustom" className="pswp" tabIndex="-1" role="dialog" aria-hidden="true">
        {showReadMore && (
          <div className="pswp__read__more" onClick={handleDescription}>
            {!captionExpand && "... "}
            +info
          </div>
        )}
        <div className="pswp__bg" />
        <div className="pswp__scroll-wrap">
          <div className="pswp__container">
            <div className="pswp__item" />
            <div className="pswp__item" />
            <div className="pswp__item" />
          </div>
          <div className="pswp__ui pswp__ui--hidden">
            <div className="pswp__top-bar">
              <div
                className={classnames("wbkv9-Gallery-closeButton", styles.closeButton)}
                onClick={this.closeModal}
                id="my_movie"
              />
              <div className="pswp__hide pswp__counter" />
              <div className="pswp__preloader">
                <div className="pswp__preloader__icn">
                  <div className="pswp__preloader__cut">
                    <div className="pswp__preloader__donut" />
                  </div>
                </div>
              </div>
              <button
                className="pswp__hide pswp__button pswp__button--fs"
                title="Toggle fullscreen"
              />
              <button className="pswp__hide pswp__button pswp__button--share" title="Share" />
              <button className="pswp__hide pswp__button pswp__button--zoom" title="Zoom in/out" />
              {showReadMore && (
                <div
                  className="pswp__button pswp__button--info"
                  title="Inventory description expand"
                  onClick={handleDescription}>
                  <InfoIcon />
                </div>
              )}
            </div>
            <div className="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">
              <div className="pswp__share-tooltip" />
            </div>
            <button
              className="pswp__button pswp__button--arrow--left"
              title="Previous (arrow left)">
              <NavigateBeforeIcon onClick={handlePrev} />
            </button>
            <button className="pswp__button pswp__button--arrow--right" title="Next (arrow right)">
              <NavigateNextIcon onClick={handleNext} />
            </button>
            <div className={classnames("pswp__caption", captionExpand && "expanded")}>
              <div className="pswp__caption__center" />
            </div>
            {description && (
              <div className="pswp__description">
                <div className="descriptionContainer">
                  <div className="title">{title}</div>
                  <div className="description" dangerouslySetInnerHTML={renderHTML(description)} />
                  {type !== "service" && (
                    <div
                      onClick={event => {
                        event.preventDefault();
                        event.stopPropagation();
                        handleInventory(
                          inventory && inventory.ticker,
                          inventory && inventory.callback
                        );
                      }}>
                      <div className="bookButtonContainer">
                        <button>
                          {infoOnly ? (
                            <FormattedMessage {...msgs.close} />
                          ) : (
                            <FormattedMessage {...msgs.book} />
                          )}
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}
